import React, { Component } from 'react'
import { observer } from  'mobx-react'
import Material from  '../Material'
import AnswerAnalysis from '../Material/AnswerAnalysis'
import styles from  './questions.css'

@observer(['practiceStore'])
export default class MultipleQuestion extends Component {

  handleClickChecked(e) {
    const { practiceStore, questionIndex, answer } = this.props
    const value = parseInt(e.target.value, 10)
    const userAnswer = practiceStore.userAnswer.toJSON()
    const answerIndex = userAnswer ? userAnswer[questionIndex].answer.split(',') : []
    if (answerIndex.length > 0 && answerIndex[0] === '') {
      answerIndex.splice(0, 1)
    }
    const valIndex = answerIndex.indexOf(`${value}`)

    if (valIndex === -1) {
      answerIndex.push(value)
    } else {
      answerIndex.splice(valIndex, 1)
    }

    const correctAnswer = answer.sort().join()
    const answerStr = answerIndex.sort().join()

    userAnswer[questionIndex].answer = answerStr
    userAnswer[questionIndex].isCorrect = answerStr === correctAnswer
    practiceStore.saveAnswer(userAnswer)
  }

  renderChoice() {
    const { practiceStore, questionIndex, choices, answer} = this.props
    const userAnswer = practiceStore.userAnswer.toJSON()
    const highlight = practiceStore.show.answer

    return choices.map((item, index) => {
      let checked = userAnswer[questionIndex] ?
      userAnswer[questionIndex].answer && userAnswer[questionIndex].answer.indexOf(index) >= 0 : false

      let highlightClass = ''
      if (highlight) {
        let isCorrect = answer.indexOf(index) >= 0
        if (isCorrect) { //如果当前选项是正确答案
          highlightClass = styles.highlight
        } else {
          if (checked) {
            highlightClass = styles.error
          }
        }
      }

      return (
        <li key={`${practiceStore.id}${questionIndex}${index}`}>
          <label htmlFor={`MultipleQuestion${questionIndex}${index}`}>
            <input
              type='checkbox'
              id={`MultipleQuestion${questionIndex}${index}`}
              value={ index }
              defaultChecked={ checked }
              onChange={ e => this.handleClickChecked(e) }
            />
          <span className={ highlightClass }>
            { String.fromCharCode(index + 65) } . {item}
          </span>
          </label>
        </li>
      );
    })
  }

  render() {
    const { practiceStore, question, answer_analysis ,category } = this.props
    return (
      <div>
        <Material stem={ question } category={category} />
        <ul className={ styles.multiple }>
          { this.renderChoice() }
        </ul>
        { practiceStore.show.answer ?
          <AnswerAnalysis analysisAnswer={ answer_analysis } />
          : null
        }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Question/MultipleQuestion.js
 **/